import React from 'react';
import { CardActions } from '@material-ui/core';

const ResponsiveCardActions: React.FC = ({ children }) => {
  return (
    <CardActions>
      {children}
    </CardActions>
  )
}

export default ResponsiveCardActions;
